exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.remove-address[data-v-1b6a8e7c] {\n    margin-right: 20px;\n}\n", ""]);

// exports
